import axios from "@/axios.js";
import constants from "@/constants.js";

export default {
  async createCheckoutSession({ commit }, payload) {
    try {
      const response = await axios.post('https://api-core.getboarded.com/api/subscriptions/create-checkout', payload);
      return response.data;
    } catch (error) {
      console.error('Failed to create checkout session:', error);
      return null;
    }
  },

  async createCustomerPortal({ commit }, payload) {
    try {
      const response = await axios.post('https://api-core.getboarded.com/api/subscriptions/create-portal', payload);
      return response.data;
    } catch (error) {
      console.error('Failed to create checkout session:', error);
      return null;
    }
  },

  async getUserSubscription({ commit }, payload) {
    try {
      const response = await axios.post('https://api-core.getboarded.com/api/subscriptions/current', payload);
      commit("SET_CURRENT_PLAN", response.data);
      return response.data;
    } catch (error) {
      console.error('Failed to create checkout session:', error);
      return null;
    }
  },

  async addFunds({ commit }, fundsData) {
    try {
      const resObj = await axios.post(
        `${constants.paymentsServiceUrl}/funds/deposit`,
        fundsData
      );
      commit(
        "SET_FUNDS_DATA",
        resObj.data
          ? resObj.data.data
            ? resObj.data.data.fundsRecord
              ? resObj.data.data.fundsRecord.amount
              : 0
            : 0
          : 0
      );
      commit(
        "UPDATE_TRANSACTION_HISTORY",
        resObj.data
          ? resObj.data.data
            ? resObj.data.data.transactionRecord
            : []
          : []
      );
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async fetchFunds({ commit }, { organizationId }) {
    try {
      const resObj = await axios.get(
        `${constants.paymentsServiceUrl}/funds/${organizationId}`
      );
      commit(
        "SET_FUNDS_DATA",
        resObj.data ? (resObj.data.data ? resObj.data.data.amount : 0) : 0
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async fetchUserTransactions({ commit }, { userId }) {
    return new Promise(async (resolve, reject) => {
      try {
        const userTransactions = await axios.get(
          `${constants.gatewayServiceUrl}/user-wallet/transactions/${userId}`
        );
        userTransactions.data.data.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        commit(
          "SET_USER_TRANSACTION",
          userTransactions.data.data ? userTransactions.data.data : []
        );
        resolve(userTransactions.data.data ? userTransactions.data.data : []);
      } catch (error) {
        reject(error);
      }
    });
  },
  async fetchAllTransactions(
    { commit },
    { organizationId, userId, accessToken }
  ) {
    return new Promise(async (resolve, reject) => {
      try {
        const resObj = await axios.get(
          `${constants.paymentsServiceUrl}/payment/transactions/${organizationId}`
        );
        const marketTransactions = await axios.get(
          `${constants.marketAdminUrl}/get-logs?userId=${userId}&orgId=${organizationId}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        // console.log("marketTransactions", marketTransactions);
        const allTransactions = [
          ...(marketTransactions.data.logs || []),
          ...resObj.data.data,
        ];
        allTransactions.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        // console.log("allTransactions", allTransactions);
        commit(
          "SET_TRANSACTION_HISTORY",
          resObj.data ? (resObj.data.data ? allTransactions : []) : []
        );
        resolve(resObj.data ? (resObj.data.data ? allTransactions : []) : []);
      } catch (error) {
        reject(error);
      }
    });
  },
  async fetchBoardPrice({ commit }, payload) {
    try {
      const resObj = await axios.post(
        `${constants.paymentsServiceUrl}/payment/board-price`,
        payload
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async fetchAppPrice({ commit }) {
    try {
      const resObj = await axios.get(
        `${constants.paymentsServiceUrl}/payment/app-price`
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async createTransaction({ commit }, payload) {
    try {
      const resObj = await axios.post(
        `${constants.paymentsServiceUrl}/payment/transaction`,
        payload
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async addCreditsToBoard({ commit }, payload) {
    try {
      const resObj = await axios.post(
        `${constants.paymentsServiceUrl}/credits/add`,
        payload
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async creditsToFunds({ commit }, payload) {
    try {
      const resObj = await axios.post(
        `${constants.paymentsServiceUrl}/payment/credits-to-funds`,
        payload
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async fetchCredits({ commit }, { boardId }) {
    try {
      const resObj = await axios.get(
        `${constants.paymentsServiceUrl}/credits/${boardId}`
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async removeCredits({ commit }, payload) {
    try {
      const resObj = await axios.post(
        `${constants.paymentsServiceUrl}/credits/remove`,
        payload
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
};
